import * as React from 'react'
import { useMutation, useQuery } from '@apollo/react-hooks'
import { Col } from 'antd'
import { useFormik } from 'formik'
import * as moment from 'moment'
import { colors } from 'web-makeup/dist/design-system/config/data/theme'
import { map } from 'lodash'

import { Brand as BrandType, PayCycle, WeekDay } from '../../../../typings/types'
import { UPDATE_BRAND_PROFILE } from '../../../../mutations/UpdateBrandProfile'
import { ALL_CUSTOMER_CONTRACT_INVOICES_V2 } from '../../../../queries/AllCostumerContractInvoicesv2'
import { ALL_CREDIT_CARDS } from '../../../../queries/AllCreditCards'
import { numberWithCommas } from '../../../../helpers/priceFormater'

import EnvironmentContext from '../../../EnvironmentContext'
import { client as apolloClient } from '../../../ApolloProvider/ApolloProvider'

import {
  ButtonWrapper,
  Input,
  InputLabel,
  StyledRow,
  StyledSelect,
} from '../../BrandDashboardSettings/BrandDashboardSettings.style'
import DefaultButton from '../../components/DefaultButton/DefaultButton'
import { PayCycleLabels } from '../../enums/brand-dashboard'
import { CreditCards } from '../../components/CreditCards/CreditCards'

import {
  H1,
  H0,
  WhiteBox,
  CustomTable,
  BillingWrap,
  H4,
  PageSection,
  A,
  GlobalStyles,
  LightParagraph,
  StyledH5,
  BackLink,
  MobileInvoices,
  MobiileInvoicesCard,
  H5,
  H6,
  FlexRow,
  H8,
  UpperText,
  Hr,
  MobileH6,
  CardHead,
  CardFooter,
  TableWhiteBox,
  InvoiceStatus,
  MobileH5,
  MobileHistoryInvoices,
} from '../BrandDashboardPayments.style'

interface PaymentsProps {
  brandProfile?: BrandType
  brandOrderUuid?: string
}

const Payments: React.FC<PaymentsProps> = ({ brandProfile, brandOrderUuid }) => {
  const [paymentHisoryActive, setPaymentHistoryActive] = React.useState(false)

  const [brandPaymentsInitialState, useBrandPaymentsInitialState] = React.useState({
    billingName: '',
    addressType: '',
    billingCountry: '',
    billingCity: '',
    billingAddressLine1: '',
    billingAddressLine2: '',
    billingAddressLine3: '',
    billingAddressPostCode: '',
    payCycle: '',
    weekly: WeekDay.MON,
    monthly: 1,
    endOfMonth: 0,
    fromIssueDate: 0,
  })

  const { Option } = StyledSelect
  const { GEN1_BASE_URL } = React.useContext(EnvironmentContext) || ''

  const {
    billingAddressCity,
    billingAddressCountry,
    billingAddressLine1,
    billingAddressLine2,
    billingAddressLine3,
    billingAddressPostCode,
    billingAddressType,
    billingName,
    payCycle,
    tradingName,
    payCycleData,
  } = brandProfile || {}
  React.useEffect(
    () => {
      brandProfile &&
        useBrandPaymentsInitialState({
          billingName: billingName || '',
          addressType: billingAddressType || '',
          billingCountry: billingAddressCountry || '',
          billingCity: billingAddressCity || '',
          billingAddressLine1: billingAddressLine1 || '',
          billingAddressLine2: billingAddressLine2 || '',
          billingAddressLine3: billingAddressLine3 || '',
          billingAddressPostCode: billingAddressPostCode || '',
          payCycle: payCycle || '',
          weekly: (payCycleData && payCycleData.weekly) || brandPaymentsInitialState.weekly,
          monthly: (payCycleData && payCycleData.monthly) || brandPaymentsInitialState.monthly,
          endOfMonth:
            (payCycleData && payCycleData.endOfMonth) || brandPaymentsInitialState.endOfMonth,
          fromIssueDate:
            (payCycleData && payCycleData.fromIssueDate) || brandPaymentsInitialState.fromIssueDate,
        })
    },
    [brandProfile]
  )

  const [updateBrandProfile, { loading: brandPaymentsUpdating }] = useMutation(
    UPDATE_BRAND_PROFILE,
    {
      client: apolloClient,
    }
  )

  const { data: unPaidInvoicesData } = useQuery(ALL_CUSTOMER_CONTRACT_INVOICES_V2, {
    variables: { brandUuid: brandOrderUuid, paid: false, pageSize: 150 },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })
  const { allCustomerContractInvoices: unPaidInvoicesObject } = unPaidInvoicesData || ''
  const { invoices: allUnPaidInvoices } = unPaidInvoicesObject || ''

  const { data: paidInvoicesData } = useQuery(ALL_CUSTOMER_CONTRACT_INVOICES_V2, {
    variables: { brandUuid: brandOrderUuid, paid: true, pageSize: 150 },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })
  const { allCustomerContractInvoices: paidInvoicesObject } = paidInvoicesData || ''
  const { invoices: allPaidInvoices } = paidInvoicesObject || ''

  const filteredPaidInvoicesDataV2 = data => {
    const allPaidInvoicesFiltered =
      data &&
      data.filter(invoice => invoice.customerContract && invoice.customerContract.signedAt !== null)
    const filteredInvoices =
      allPaidInvoicesFiltered &&
      allPaidInvoicesFiltered.map(inv => {
        return inv.customerContract.invoices
      })
    return filteredInvoices && filteredInvoices.flat(1)
  }

  const { data: creditCardsData } = useQuery(ALL_CREDIT_CARDS, {
    variables: { brandUuid: brandOrderUuid },
    errorPolicy: 'all',
    fetchPolicy: 'cache-and-network',
    client: apolloClient,
  })

  const { allCreditCards } = creditCardsData || ''

  const brandDetailsformik = useFormik({
    initialValues: {
      ...brandPaymentsInitialState,
    },
    enableReinitialize: true,
    onSubmit: values => {
      updateBrandProfile({
        variables: {
          brandUuid: brandOrderUuid,
          brandUpdateInput: {
            billingName: values.billingName,
            billingAddressCountry: values.billingCountry,
            billingAddressCity: values.billingCity,
            billingAddressLine1: values.billingAddressLine1,
            billingAddressLine2: values.billingAddressLine2,
            billingAddressLine3: values.billingAddressLine3,
            billingAddressPostCode: values.billingAddressPostCode,
            billingAddressType: values.addressType,
            payCycle: values.payCycle,
            payCycleData: {
              weekly: values.weekly,
              monthly: values.monthly,
              endOfMonth: values.endOfMonth,
              fromIssueDate: values.fromIssueDate,
            },
          },
        },
      })
    },
  })

  interface SectionHeadProps {
    title: string
    subTitle?: string | React.ReactNode
  }

  const SectionHead: React.FC<SectionHeadProps> = ({ title, subTitle }) => {
    return (
      <>
        <H1>{title}</H1>
        {subTitle && <H4>{subTitle}</H4>}
      </>
    )
  }
  const inputClass = (field: any) => {
    return field === '' ? '' : 'filled'
  }

  const overdueInvoices =
    filteredPaidInvoicesDataV2(allUnPaidInvoices) &&
    filteredPaidInvoicesDataV2(allUnPaidInvoices).length > 0 &&
    filteredPaidInvoicesDataV2(allUnPaidInvoices).filter(invo => {
      const today = new Date()
      const isOverdue = invo.dueDate && moment(invo.dueDate).isBefore(today)
      if (isOverdue) {
        return invo
      }
    })
  const getOrdinal = n => {
    const s = ['th', 'st', 'nd', 'rd']
    const v = n % 100
    return n + (s[(v - 20) % 10] || s[v] || s[0])
  }
  const monthDays = 31
  const plusDays = 91
  return (
    <>
      <GlobalStyles />
      {paymentHisoryActive ? (
        <>
          <BackLink
            onClick={() => {
              setPaymentHistoryActive(false)
            }}
          >
            Back
          </BackLink>
          <H0>Payment history</H0>
          <H4>
            Below is a list of paid video project invoices.{' '}
            <A
              href="#"
              onClick={e => {
                e.preventDefault()
                setPaymentHistoryActive(false)
              }}
            >
              Return to Account.
            </A>
          </H4>
          <MobileHistoryInvoices>
            {filteredPaidInvoicesDataV2(allPaidInvoices) &&
              filteredPaidInvoicesDataV2(allPaidInvoices).length > 0 &&
              filteredPaidInvoicesDataV2(allPaidInvoices).map(inv => {
                const { price, total, tax, customerContract } = inv || ''
                const invoiceName = inv.description
                const today = new Date()
                const isOverdue = inv.dueDate && moment(inv.dueDate).isBefore(today)
                const projectTitle =
                  customerContract && customerContract.projects && customerContract.projects[0].name
                const projectTitleUpdated = () => {
                  if (projectTitle && projectTitle.length > 17) {
                    return `${projectTitle.substring(0, 17)}...`
                  }
                  return projectTitle
                }
                const orderUrl = `https://payment.90seconds.cc/${inv.uuid}`
                const customerContractUrl =
                  customerContract && `${GEN1_BASE_URL}/customer_contracts/${customerContract.uuid}`
                return (
                  <MobiileInvoicesCard key={inv.uuid}>
                    <InvoiceStatus className={isOverdue ? `red` : `yellow`}>
                      {isOverdue ? 'Overdue' : 'Pending'}
                    </InvoiceStatus>
                    <CardHead>
                      <MobileH5>
                        <a href={customerContractUrl}>
                          <span className={isOverdue ? `overdue` : ``} />
                          {projectTitleUpdated()}
                        </a>
                      </MobileH5>
                      <H6>{invoiceName}</H6>
                    </CardHead>
                    <FlexRow>
                      <UpperText>Amount</UpperText>
                      <span>
                        <H8>{price && price.currency && price.currency.code}</H8>
                        {` `}
                        <MobileH6>
                          {price && price.currency && price.currency.symbol}
                          {price && numberWithCommas(price.amount)}
                        </MobileH6>
                      </span>
                    </FlexRow>
                    <FlexRow>
                      <UpperText>Sales tax</UpperText>
                      <span>
                        <H8>{tax && tax.currency && tax.currency.code}</H8>
                        {` `}
                        <MobileH6>
                          {tax && tax.currency && tax.currency.symbol}
                          {tax && numberWithCommas(tax.amount)}
                        </MobileH6>
                      </span>
                    </FlexRow>
                    <Hr />
                    <FlexRow>
                      <UpperText>Total</UpperText>
                      <span>
                        <H8>{total && total.currency && total.currency.code}</H8>
                        {` `}
                        <MobileH6>
                          {total && total.currency && total.currency.symbol}
                          {total && numberWithCommas(total.amount)}
                        </MobileH6>
                      </span>
                    </FlexRow>
                    <Hr />
                    <CardFooter>
                      <FlexRow>
                        <span>
                          <UpperText>Due</UpperText>
                          <H5>28 Aug 2022</H5>
                        </span>
                        <DefaultButton
                          fontSize="0.875rem"
                          padding="0 1.625rem"
                          backgroundColor={colors.action2}
                          borderColor={colors.action2}
                          color="white"
                          buttonHeight="2rem"
                          rounded
                          hoverBackground={colors.action2Hover}
                          hoverColor="white"
                          onClick={() => {
                            window.open(orderUrl, '_blank')
                          }}
                        >
                          Pay
                        </DefaultButton>
                      </FlexRow>
                    </CardFooter>
                  </MobiileInvoicesCard>
                )
              })}
          </MobileHistoryInvoices>
          <TableWhiteBox>
            <CustomTable>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Project</th>
                  <th>
                    <strong>Due</strong>
                  </th>
                  <th>
                    <strong>Paid</strong>
                  </th>
                  <th>
                    <strong>Amount</strong>
                  </th>
                  <th>
                    <strong>Sales Tax</strong>
                  </th>
                  <th>
                    <strong>Total</strong>
                  </th>
                  <th>
                    <strong>Status</strong>
                  </th>
                </tr>
              </thead>
              <tbody>
                {filteredPaidInvoicesDataV2(allPaidInvoices) &&
                  filteredPaidInvoicesDataV2(allPaidInvoices).length > 0 &&
                  filteredPaidInvoicesDataV2(allPaidInvoices).map((inv, index) => {
                    const { price, total, tax, customerContract } = inv || ''
                    const invoiceName = inv.description
                    const projectTitle =
                      customerContract &&
                      customerContract.projects &&
                      customerContract.projects[0].name
                    const projectTitleUpdated = () => {
                      if (projectTitle && projectTitle.length > 17) {
                        return `${projectTitle.substring(0, 17)}...`
                      }
                      return projectTitle
                    }
                    const customerContractUrl =
                      customerContract &&
                      `${GEN1_BASE_URL}/customer_contracts/${customerContract.uuid}`
                    return (
                      <tr key={inv.uuid}>
                        <td>{index + 1}</td>
                        <td className="title">
                          <a href={customerContractUrl} target="_blank">
                            {projectTitleUpdated()}
                          </a>
                          <div>{invoiceName}</div>
                        </td>
                        <td className={`due ${inv.dueDate ? '' : 'center'}`}>
                          {inv.dueDate ? moment(inv.dueDate).format('DD MMM Y') : `-`}
                        </td>
                        <td className={`due ${inv.dueDate ? '' : 'center'}`}>
                          {inv.dueDate ? moment(inv.dueDate).format('DD MMM Y') : `-`}
                        </td>
                        <td>
                          <span>{price && price.currency && price.currency.code}</span>{' '}
                          {price && price.currency && price.currency.symbol}
                          {price && numberWithCommas(price.amount)}
                        </td>
                        <td>
                          <span>{tax && tax.currency && tax.currency.code}</span>{' '}
                          {tax && tax.currency && tax.currency.symbol}
                          {tax && numberWithCommas(tax.amount)}
                        </td>
                        <td>
                          <span>{total && total.currency && total.currency.code}</span>{' '}
                          {total && total.currency && total.currency.symbol}
                          {total && numberWithCommas(total.amount)}
                        </td>
                        <td className="paid">
                          <img
                            src="https://res.cloudinary.com/ninety-seconds/image/upload/v1610721523/Engineering/badge-configured.svg"
                            alt="Badge icon"
                          />
                          Paid
                        </td>
                      </tr>
                    )
                  })}
              </tbody>
            </CustomTable>
          </TableWhiteBox>
        </>
      ) : (
        <>
          <BillingWrap>
            <H0>Billing and Payments</H0>
            <H4>
              This is the account page. It gives access to all of the brand account details,
              including <br />
              membership, invoices, payment history and default billing details. View{' '}
              <A
                href={`${GEN1_BASE_URL}/organisations/${brandOrderUuid}/private_comms`}
                target="_blank"
              >
                Private Comms.
              </A>
            </H4>
          </BillingWrap>
          <PageSection>
            <SectionHead
              title="Video Project Invoices"
              subTitle={
                <>
                  Below is a list of project invoices that require payment. View{' '}
                  <A
                    href="!#"
                    onClick={e => {
                      e.preventDefault()
                      setPaymentHistoryActive(true)
                    }}
                  >
                    invoices and payment history
                  </A>
                  .
                </>
              }
            />
            <MobileInvoices>
              {filteredPaidInvoicesDataV2(allUnPaidInvoices) &&
                filteredPaidInvoicesDataV2(allUnPaidInvoices).length > 0 &&
                filteredPaidInvoicesDataV2(allUnPaidInvoices).map(inv => {
                  const { price, total, tax, customerContract } = inv || ''
                  const invoiceList =
                    customerContract &&
                    customerContract.invoices &&
                    customerContract.invoices.filter(invoice => invoice.uuid === inv.uuid)
                  const invoiceName = invoiceList && invoiceList[0] && invoiceList[0].description
                  const today = new Date()
                  const isOverdue = inv.dueDate && moment(inv.dueDate).isBefore(today)
                  const projectTitle =
                    customerContract &&
                    customerContract.projects &&
                    customerContract.projects[0].name
                  const projectTitleUpdated = () => {
                    if (projectTitle && projectTitle.length > 17) {
                      return `${projectTitle.substring(0, 17)}...`
                    }
                    return projectTitle
                  }
                  const customerContractUrl =
                    customerContract &&
                    `${GEN1_BASE_URL}/customer_contracts/${customerContract.uuid}`
                  return (
                    <MobiileInvoicesCard key={inv.uuid}>
                      <InvoiceStatus className={isOverdue ? `red` : `yellow`}>
                        {isOverdue ? 'Overdue' : 'Pending'}
                      </InvoiceStatus>
                      <CardHead>
                        <MobileH5>
                          <a href={customerContractUrl}>
                            <span className={isOverdue ? `overdue` : ``} />
                            {projectTitleUpdated()}
                          </a>
                        </MobileH5>
                        <H6>{invoiceName}</H6>
                      </CardHead>
                      <FlexRow>
                        <UpperText>Amount</UpperText>
                        <span>
                          <H8>{price && price.currency && price.currency.code}</H8>
                          {` `}
                          <MobileH6>
                            {price && price.currency && price.currency.symbol}
                            {price && numberWithCommas(price.amount)}
                          </MobileH6>
                        </span>
                      </FlexRow>
                      <FlexRow>
                        <UpperText>Sales tax</UpperText>
                        <span>
                          <H8>{tax.currency && tax.currency.code}</H8>
                          {` `}
                          <MobileH6>
                            {tax.currency && tax.currency.symbol}
                            {numberWithCommas(tax.amount)}
                          </MobileH6>
                        </span>
                      </FlexRow>
                      <Hr />
                      <FlexRow>
                        <UpperText>Total</UpperText>
                        <span>
                          <H8>{total.currency && total.currency.code}</H8>
                          {` `}
                          <MobileH6>
                            {total.currency && total.currency.symbol}
                            {numberWithCommas(total.amount)}
                          </MobileH6>
                        </span>
                      </FlexRow>
                      <Hr />
                      <CardFooter>
                        <FlexRow>
                          <span>
                            <UpperText>Due</UpperText>
                            <H5>28 Aug 2022</H5>
                          </span>
                          <DefaultButton
                            fontSize="0.875rem"
                            padding="0 1.625rem"
                            backgroundColor={colors.action2}
                            borderColor={colors.action2}
                            color="white"
                            buttonHeight="2rem"
                            rounded
                            hoverBackground={colors.action2Hover}
                            hoverColor="white"
                          >
                            Pay
                          </DefaultButton>
                        </FlexRow>
                      </CardFooter>
                    </MobiileInvoicesCard>
                  )
                })}
            </MobileInvoices>
            <TableWhiteBox>
              <CustomTable>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Project</th>
                    <th>
                      <strong>Status</strong>
                    </th>
                    <th>
                      <strong>Due</strong>
                    </th>
                    <th>
                      <strong>Amount</strong>
                    </th>
                    <th>
                      <strong>Sales Tax</strong>
                    </th>
                    <th>
                      <strong>Total</strong>
                    </th>
                    <th className="payment">
                      <strong>Payment</strong>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {filteredPaidInvoicesDataV2(allUnPaidInvoices) &&
                    filteredPaidInvoicesDataV2(allUnPaidInvoices).length > 0 &&
                    filteredPaidInvoicesDataV2(allUnPaidInvoices).map((inv, index) => {
                      const { price, total, tax, customerContract } = inv || ''
                      const invoiceName = inv.description
                      const today = new Date()
                      const isOverdue = inv.dueDate && moment(inv.dueDate).isBefore(today)
                      const projectTitle =
                        customerContract &&
                        customerContract.projects &&
                        customerContract.projects[0].name
                      const projectTitleUpdated = () => {
                        if (projectTitle.length > 20) {
                          return `${projectTitle.substring(0, 20)}...`
                        }
                        return projectTitle
                      }
                      const orderUrl = `https://payment.90seconds.cc/${inv.uuid}`
                      const customerContractUrl =
                        customerContract &&
                        `${GEN1_BASE_URL}/customer_contracts/${customerContract.uuid}`
                      return (
                        <tr key={inv.uuid}>
                          <td>{index + 1}</td>
                          <td className="title">
                            <a href={customerContractUrl} target="_blank">
                              <span className={isOverdue ? `overdue` : ``} />
                              {projectTitleUpdated()}
                            </a>
                            <div>{invoiceName}</div>
                          </td>
                          <td className={`status ${isOverdue ? 'red' : 'yellow'}`}>
                            {isOverdue ? 'Overdue' : 'Pending'}
                          </td>
                          <td className={`due ${inv.dueDate ? '' : 'center'}`}>
                            {inv.dueDate ? moment(inv.dueDate).format('DD MMM Y') : `-`}
                          </td>
                          <td>
                            <span>{price.currency && price.currency.code}</span>{' '}
                            {price.currency && price.currency.symbol}
                            {numberWithCommas(price.amount)}
                          </td>
                          <td>
                            <span>{tax.currency && tax.currency.code}</span>{' '}
                            {tax.currency && tax.currency.symbol}
                            {numberWithCommas(tax.amount)}
                          </td>
                          <td>
                            <span>{total.currency && total.currency.code}</span>{' '}
                            {total.currency && total.currency.symbol}
                            {numberWithCommas(total.amount)}
                          </td>
                          <td>
                            <DefaultButton
                              fontSize="0.875rem"
                              padding="0 1.625rem"
                              backgroundColor={colors.action2}
                              borderColor={colors.action2}
                              color="white"
                              buttonHeight="2rem"
                              rounded
                              hoverBackground={colors.action2Hover}
                              hoverColor="white"
                              onClick={() => {
                                window.open(orderUrl, '_blank')
                              }}
                            >
                              Pay
                            </DefaultButton>
                          </td>
                        </tr>
                      )
                    })}
                </tbody>
              </CustomTable>
            </TableWhiteBox>
            {overdueInvoices && (
              <H5 style={{ color: colors.alert, paddingTop: '0.75rem' }}>
                <strong>
                  {overdueInvoices.map((invo, index) => {
                    const invoiceList =
                      filteredPaidInvoicesDataV2(allUnPaidInvoices) &&
                      filteredPaidInvoicesDataV2(allUnPaidInvoices).filter(
                        invoice => invoice.uuid === invo.uuid
                      )
                    const invoiceName = invoiceList && invoiceList[0] && invoiceList[0].description
                    if (index > 0) {
                      return
                    }
                    return `${invoiceName} ${
                      overdueInvoices.length > 1 ? `and ${overdueInvoices.length - 1} more` : ``
                    }`
                  })}
                </strong>{' '}
                {overdueInvoices.length < 3 ? `is` : `are`} overdue. If you think this is a mistake,{' '}
                <strong>contact with us.</strong>
              </H5>
            )}
          </PageSection>
          <PageSection>
            <SectionHead
              title="Credit Cards"
              subTitle={
                <>
                  These are the cards that are loaded onto this account, as well as the people that
                  can access them. <br />
                  These cards can be used to pay for any transaction on the platform.
                  {` `}
                  <A
                    href={`${GEN1_BASE_URL}/organisations/${brandOrderUuid}/private_comms`}
                    target="_blank"
                  >
                    Add another credit card.
                  </A>
                </>
              }
            />
            <WhiteBox>
              <StyledH5>Just for me</StyledH5>
              <LightParagraph>These cards can only be seen and used by you.</LightParagraph>
              <CreditCards isLimited cards={allCreditCards} />
              <StyledH5>For everyone at {tradingName}</StyledH5>
              <LightParagraph>
                These cards can only be seen and used by anyone who is an Administrator, Decision
                Maker or Accounts person on your brand. Restricted team members cannot see or use
                the cards.
              </LightParagraph>
              <CreditCards isLimited={false} cards={allCreditCards} />
            </WhiteBox>
          </PageSection>
          <PageSection>
            <SectionHead
              title="My Billing Details"
              subTitle="Any details added below will be added to your invoices as the billing details."
            />
            <form onSubmit={brandDetailsformik.handleSubmit}>
              <WhiteBox>
                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputLabel>Billing Name*</InputLabel>
                    <Input
                      type="text"
                      placeholder="Billing Name"
                      name="billingName"
                      className={inputClass(brandDetailsformik.values.billingName)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingName', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingName: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingName}
                    />
                  </Col>
                </StyledRow>
                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputLabel>Address type</InputLabel>
                    <StyledSelect
                      // className={`filled`}
                      placeholder="Address type"
                      name="addressType"
                      className={inputClass(brandDetailsformik.values.addressType)}
                      onChange={value => {
                        brandDetailsformik.setFieldValue('addressType', value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          addressType: value,
                        })
                      }}
                      value={brandDetailsformik.values.addressType}
                      showSearch
                      suffixIcon={
                        <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                      }
                    >
                      <Option value="street">Street Address</Option>
                      <Option value="pobox">PO Box Number</Option>
                    </StyledSelect>
                  </Col>
                </StyledRow>
                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <InputLabel>Country</InputLabel>
                    <Input
                      type="text"
                      placeholder="Country"
                      name="billingCountry"
                      className={inputClass(brandDetailsformik.values.billingCountry)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingCountry', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingCountry: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingCountry}
                    />
                  </Col>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <InputLabel>City/State</InputLabel>
                    <Input
                      type="text"
                      placeholder="City"
                      name="billingCity"
                      className={inputClass(brandDetailsformik.values.billingCity)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingCity', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingCity: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingCity}
                    />
                  </Col>
                </StyledRow>
                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputLabel>Address Line 1</InputLabel>
                    <Input
                      type="text"
                      placeholder="Address Line 1"
                      name="billingAddressLine1"
                      className={inputClass(brandDetailsformik.values.billingAddressLine1)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingAddressLine1', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingAddressLine1: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingAddressLine1}
                    />
                  </Col>
                </StyledRow>
                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputLabel>Address Line 2</InputLabel>
                    <Input
                      type="text"
                      placeholder="Address Line 2"
                      name="billingAddressLine2"
                      className={inputClass(brandDetailsformik.values.billingAddressLine2)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingAddressLine2', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingAddressLine2: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingAddressLine2}
                    />
                  </Col>
                </StyledRow>

                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputLabel>Address Line 3</InputLabel>
                    <Input
                      type="text"
                      placeholder="Address Line 3"
                      name="billingAddressLine3"
                      className={inputClass(brandDetailsformik.values.billingAddressLine3)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingAddressLine3', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingAddressLine3: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingAddressLine3}
                    />
                  </Col>
                </StyledRow>

                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={24} lg={24}>
                    <InputLabel>Postal/Zip Code</InputLabel>
                    <Input
                      type="text"
                      placeholder="Postal/Zip Code"
                      name="billingAddressPostCode"
                      className={inputClass(brandDetailsformik.values.billingAddressPostCode)}
                      onChange={e => {
                        brandDetailsformik.setFieldValue('billingAddressPostCode', e.target.value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          billingAddressPostCode: e.target.value,
                        })
                      }}
                      value={brandDetailsformik.values.billingAddressPostCode}
                    />
                  </Col>
                </StyledRow>

                <StyledRow type="flex" gutter={24}>
                  <Col xs={24} sm={24} md={12} lg={12}>
                    <InputLabel>Pay Cycle</InputLabel>
                    <StyledSelect
                      type="text"
                      placeholder="Pay Cycle"
                      name="payCycle"
                      className={inputClass(brandDetailsformik.values.payCycle)}
                      onChange={value => {
                        brandDetailsformik.setFieldValue('payCycle', value)
                        useBrandPaymentsInitialState({
                          ...brandPaymentsInitialState,
                          payCycle: value,
                        })
                      }}
                      value={brandDetailsformik.values.payCycle}
                      suffixIcon={
                        <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                      }
                    >
                      {map(PayCycle, (obj, index) => (
                        <Option key={index} value={PayCycle[obj]}>
                          {PayCycleLabels[PayCycle[obj]]}
                        </Option>
                      ))}
                    </StyledSelect>
                  </Col>
                  {brandDetailsformik.values.payCycle === 'WEEKLY' && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <InputLabel>Every</InputLabel>
                      <StyledSelect
                        type="text"
                        placeholder=""
                        name=""
                        className={inputClass(brandDetailsformik.values.weekly)}
                        onChange={value => {
                          brandDetailsformik.setFieldValue('payCycleData', value)
                          useBrandPaymentsInitialState({
                            ...brandPaymentsInitialState,
                            weekly: value,
                          })
                        }}
                        value={brandDetailsformik.values.weekly}
                        suffixIcon={
                          <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                        }
                      >
                        {map(WeekDay, obj => (
                          <Option key={WeekDay[obj]} value={WeekDay[obj]}>
                            {WeekDay[obj]}
                          </Option>
                        ))}
                      </StyledSelect>
                    </Col>
                  )}
                  {brandDetailsformik.values.payCycle === 'MONTHLY' && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <InputLabel>On</InputLabel>
                      <StyledSelect
                        type="text"
                        placeholder=""
                        name=""
                        className={inputClass(brandDetailsformik.values.monthly)}
                        onChange={value => {
                          brandDetailsformik.setFieldValue('payCycleData', value)
                          useBrandPaymentsInitialState({
                            ...brandPaymentsInitialState,
                            monthly: value,
                          })
                        }}
                        value={brandDetailsformik.values.monthly}
                        suffixIcon={
                          <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                        }
                      >
                        {[...Array(monthDays)].map((e, i) => (
                          <Option key={i} value={i + 1}>
                            {getOrdinal(i + 1)}
                          </Option>
                        ))}
                      </StyledSelect>
                    </Col>
                  )}
                  {brandDetailsformik.values.payCycle === 'END_OF_MONTH' && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <InputLabel>Plus days</InputLabel>
                      <StyledSelect
                        type="text"
                        placeholder=""
                        name=""
                        className={inputClass(brandDetailsformik.values.endOfMonth)}
                        onChange={value => {
                          brandDetailsformik.setFieldValue('payCycleData', value)
                          useBrandPaymentsInitialState({
                            ...brandPaymentsInitialState,
                            endOfMonth: value,
                          })
                        }}
                        value={brandDetailsformik.values.endOfMonth}
                        suffixIcon={
                          <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                        }
                      >
                        {[...Array(plusDays)].map((e, i) => (
                          <Option key={i} value={i}>
                            {i}
                          </Option>
                        ))}
                      </StyledSelect>
                    </Col>
                  )}
                  {brandDetailsformik.values.payCycle === 'FROM_ISSUE_DATE' && (
                    <Col xs={24} sm={24} md={12} lg={12}>
                      <InputLabel>Plus days</InputLabel>
                      <StyledSelect
                        type="text"
                        placeholder=""
                        name=""
                        className={inputClass(brandDetailsformik.values.fromIssueDate)}
                        onChange={value => {
                          brandDetailsformik.setFieldValue('payCycleData', value)
                          useBrandPaymentsInitialState({
                            ...brandPaymentsInitialState,
                            fromIssueDate: value,
                          })
                        }}
                        value={brandDetailsformik.values.fromIssueDate}
                        suffixIcon={
                          <img src="https://res.cloudinary.com/ninety-seconds/image/upload/v1632366093/-design-system/icon-arrow-down-black.svg" />
                        }
                      >
                        {[...Array(plusDays)].map((e, i) => (
                          <Option key={i} value={i}>
                            {i}
                          </Option>
                        ))}
                      </StyledSelect>
                    </Col>
                  )}
                </StyledRow>
                <ButtonWrapper>
                  <DefaultButton
                    fontSize="1rem"
                    padding="0 1.625rem"
                    backgroundColor={colors.adaptBlue}
                    style={{ marginLeft: 'auto' }}
                    type="submit"
                    disabled={false}
                  >
                    {brandPaymentsUpdating ? 'Loading...' : 'Save changes'}
                  </DefaultButton>
                </ButtonWrapper>
              </WhiteBox>
            </form>
          </PageSection>
        </>
      )}
    </>
  )
}

export default Payments



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/BrandDashboardPayments/Payments/Payments.tsx